import { Reducer } from "redux";
import { 
    LOOKAHEAD_SELECTED,
     LookaheadAction, 
     LOOKAHEAD_TAG_DIALOG_OPEN, 
     LOOKAHEAD_TAG_DIALOG_CLOSE, 
     LOOKAHEAD_TAGS_SELECTED, 
     LOOKAHEAD_SELECTED_TAGS_CLEARED, 
     LOOKAHEAD_HISTOGRAM_TOGGLE,
     SHOW_VARIANCE_DIALOG,
     CLOSE_VARIANCE_DIALOG,
     HUDDLE_FILTER,
     SHOW_DELETE_PPC_DIALOG,
     CLOSE_DELETE_PPC_DIALOG,
     SELECT_PPC_COMMITMENT,
     ADD_PULL_DATE,
     MAKE_READY_PLAN_FILTER_BY_TRADE, 
     ON_ROW_UNSELECT,
     ON_ROW_SELECT, ON_COLUMN_SELECT, ON_ROW_DESELECT, TOGGLE_ROW_GROUP, REMOVE_ROW_GROUP, LOOKAHEAD_FORCE_REFRESH, LOOKAHEAD_FORCE_REFRESH_CLEAR, ON_ADD_UNDO_COMMAND, ON_CLEAR_UNDO_COMMAND, ON_SHIFT_UNDO_COMMAND, HUDDLE_FILTER_UP, HUDDLE_FILTER_DOWN, VIEW_REPORT_CLOSE, VIEW_REPORT_OPEN, INCREASE_BOARD_SIZE, DECREASE_BOARD_SIZE
} from "../actions/lookahead.actions";
import { LOCATION_CHANGE } from "connected-react-router";
import { TagType, SelectedTag } from "../models/ TagType";
import { VarianceTagChangeInterface } from "../actions/phaseplan.actions";
import { SET_PULL_DATE_DIALOG_OPEN, SET_PULL_DATE_DIALOG_CLOSE } from "../actions/dialog.actions";
import { PullOrPush } from "../utils/PullOrPush";
import { getKeysPressed } from "../selectors/util.selector";
import { HISTOGRAM, HISTOGRAM_WIN, HISTOGRAM_WIN_ALT } from "../actions/ui.actions";
import { constants as firebaseConstants } from "react-redux-firebase"
import { Trade } from "../models/Trade";
import { LookaheadTag } from "../models/LookaheadTag";
import { Constraint } from "../models/Constraint";
import { dockPadEntityMapToList } from "../containers/DockPadFormTemplates";
import { ColumnType } from "../components/PhasePlan/Column";
import { getLookaheadConstraints, getLookaheadMilestoneTags, getLookaheadTags, NewTagType, TagRecord } from "../selectors/lookahead.selector";
import { RowGroup } from "../models/Lookahead";
import shallowequal from 'shallowequal';
import { UndoCommand } from "../models/UndoCommand";
import moment, {Moment} from "moment";

const _ = require('lodash');

export enum  HuddleFilter {
    Daily='Daily',
    Weekly='Weekly',
    All='All'
}

export interface PullInfo {
    pullDate: string,
    pushOrPull: PullOrPush
}

export interface LookaheadState {
    readonly selectedLookaheadId: string | null,
    readonly lookaheadTagDialogOpen: boolean,
    readonly lookaheadTagToEdit: string | null,
    readonly selectedTags: Record<string, SelectedTag>,
    readonly isHistogramOpen: boolean,
    readonly varianceUpdate: Record<string, VarianceTagChangeInterface>,
    readonly isVarianceDialogOpen: boolean,
    readonly huddleFilter: HuddleFilter
    readonly isDeletePPCDialogOpen: boolean,
    readonly deletePPCId: string | null,
    readonly selectedCommitmentId: string | null,
    readonly isSetPullDateDialogDialogOpen: boolean,
    readonly pullInfo: PullInfo | null,
    readonly isMilestone: boolean | null,
    readonly tagDate: string | null,
    readonly row: number | null,
    readonly selectedRows: number[],
    readonly selectedColumns: string[],
    readonly closedRowGroups: number[],
    readonly trades: Record<string, Trade>
    readonly tags: Record<string, LookaheadTag>;
    readonly constraints: Record<string, Constraint>;
    readonly milestoneTags: Record<string, LookaheadTag>;
    readonly areas: Record<string, Area>;
    readonly tagsByColumn: Record<string, TagRecord[]>;
    readonly forceRefreshColumns: string[];
    readonly row_groups: Record<string, RowGroup>;
    readonly undoCommands: UndoCommand[]
    readonly huddleDate: string,
    readonly isReportDialogOpen: boolean,
    readonly reportViewTradeId?: string,
    readonly reportViewDate?: string,
    readonly maxBoardAppend: number,
    readonly minBoardAppend: number
}

const defaultState: LookaheadState = {
    selectedLookaheadId: null,
    lookaheadTagDialogOpen: false,
    lookaheadTagToEdit: null,
    selectedTags: {},
    isHistogramOpen: false,
    varianceUpdate: {},
    isVarianceDialogOpen: false,
    isDeletePPCDialogOpen: false,
    huddleFilter: HuddleFilter.Daily,
    deletePPCId: null,
    selectedCommitmentId: null,
    isSetPullDateDialogDialogOpen: false,
    pullInfo: null,
    isMilestone: null,
    tagDate: null,
    row: null,
    selectedRows: [],
    selectedColumns: [],
    closedRowGroups: [],
    trades: {},
    tags: {},
    milestoneTags: {},
    areas: {},
    constraints: {},
    tagsByColumn: {},
    row_groups: {},
    forceRefreshColumns: [],
    undoCommands: [],
    huddleDate: moment().format('l'),
    isReportDialogOpen: true,
    maxBoardAppend: 0,
    minBoardAppend: 0
};

const updateEntity = (entityType: string, state:LookaheadState , action: LookaheadAction | any) => {
    const oldEntity = !!state[entityType] ? state[entityType] : {}
    const newEntity = action.data

    if(!newEntity) {
        return {
            [entityType]: {}
        }
    }

    Object.keys(newEntity).forEach(key => {
        if(!oldEntity[key]) {
            delete oldEntity[key]
        } else {
            if(!_.isEqual(oldEntity[key], newEntity[key])) {
                oldEntity[key] = newEntity[key]
            }
        }
    })

    return {
        [entityType]:  newEntity
    } 
}

const updateColumn = (
    state:LookaheadState, 
    tags:Record<string, LookaheadTag>, 
    constraints:Record<string, Constraint>, 
    milestoneTags:Record<string, LookaheadTag>) => {
        const tagList: TagRecord[] = dockPadEntityMapToList({...tags, ...constraints, ...milestoneTags })
        .map(tag => {
            return {
                uid: tag.uid,
                indexId: tag.indexId,
                tradeId: tag.tradeId,
                name: tag.name,
                tagDate: tag.tagDate,
                type: getType(tag)   
            }
        })

        const newColumnData = _.groupBy(tagList, 'tagDate')

        const oldColumnData = !!state.tagsByColumn ? state.tagsByColumn : {}
        
        Object.keys(newColumnData).forEach(key => {
            
            if(!shallowequal(oldColumnData[key], newColumnData[key])) {

                oldColumnData[key] = newColumnData[key]
            }
            
        })

        Object.keys(oldColumnData).forEach(key => {
            
            if(!newColumnData[key]) {

                delete oldColumnData[key]
            }
            
        })

        return oldColumnData

        function getType(tag: { tagCardType: string; isMilestone: boolean; }) {
            if(tag.tagCardType == TagType.Constraint ) {
                return NewTagType.Constraint
            }

            if(tag.isMilestone == true) {
                return NewTagType.Milestone
            }

            return NewTagType.Lookahead
        }
}

export const lookaheadReducer: Reducer<LookaheadState> = (
	state = defaultState,
	action: LookaheadAction | any
) => {


    switch (action.type) {
        case INCREASE_BOARD_SIZE: 
            const maxBoardAppend = state.maxBoardAppend

            return {
                ...state,
                maxBoardAppend: maxBoardAppend+1
            }
        case DECREASE_BOARD_SIZE: 
            const minBoardAppend = state.minBoardAppend

            return {
                ...state,
                minBoardAppend: minBoardAppend + 1
            }
        
        case TOGGLE_ROW_GROUP:
            const row = action.payload.row

            const closedRowGroups = new Set<number>(state.closedRowGroups)
            if(closedRowGroups.has(row)){
                closedRowGroups.delete(row)
            }else {
                closedRowGroups.add(row)
            }
            return {
                ...state,
                closedRowGroups: Array.from<number>(closedRowGroups)
            }
        case REMOVE_ROW_GROUP:
            const _row = action.payload.row

            const closedRowGroupss = new Set<number>(state.closedRowGroups)
            closedRowGroupss.delete(_row)


            return {
                ...state,
                closedRowGroups: Array.from<number>(closedRowGroupss)
            }
        case ON_ROW_DESELECT: 
            return {
                ...state,
                selectedRows: []
            }
        case ON_ROW_SELECT:
            const selectedRow = action.payload.row
            const selectedRows = new Set<number>(state.selectedRows);

            if(selectedRows.has(selectedRow)) {
                selectedRows.delete(selectedRow)
            } else {
                selectedRows.add(selectedRow)
            }

            return {
                ...state,
                selectedRows: Array.from<number>(selectedRows)
            }

        case ON_ROW_UNSELECT: 
            const selectedRowDos = action.payload.row
            const selectedRowsDos = new Set<number>(state.selectedRows);

            selectedRowsDos.delete(selectedRowDos)
            return {
                ...state,
                selectedRows: Array.from<number>(selectedRowsDos)
            }
        case ON_COLUMN_SELECT:
            const selectedColumn = action.payload.column
            const selectedColumns = new Set<string>(state.selectedColumns);

            if(selectedColumns.has(selectedColumn)) {
                selectedColumns.delete(selectedColumn)
            } else {
                selectedColumns.add(selectedColumn)
            }

            return {
                ...state,
                selectedColumns: Array.from<string>(selectedColumns)
            }
        case LOOKAHEAD_SELECTED: 
            return {
                ...state,
                selectedLookaheadId: action.payload.lookaheadId
            }
        case LOOKAHEAD_TAG_DIALOG_OPEN:
            return {
                ...state,
                lookaheadTagDialogOpen: true,
                lookaheadTagToEdit: action.payload.tagId,
                isMilestone: action.payload.isMilestone,
                tagDate: action.payload.tagDate,
                row: action.payload.row,

            }
        case LOOKAHEAD_TAG_DIALOG_CLOSE:
            return {
                ...state,
                lookaheadTagDialogOpen: false,
                lookaheadTagToEdit: null
            }
        case VIEW_REPORT_OPEN: {
            return {
                ...state,
                isReportDialogOpen: true,
                reportViewTradeId: action.payload.tradeId,
                reportViewDate: action.payload.reportDate

            }
        }
        case VIEW_REPORT_CLOSE: {
            return {
                ...state,
                isReportDialogOpen: false,
                reportViewTradeId: null,
                reportViewDate: null
            }
        }

        case LOOKAHEAD_TAGS_SELECTED:
            if(_.isEqual(state.selectedTags, action.payload.tags)) {
                return state
            } 
            return {
                ...state,
                selectedTags: {...action.payload.tags}
            }
        case LOOKAHEAD_SELECTED_TAGS_CLEARED:
            if(_.isEqual(state.selectedTags, {})) {
                return state
            } 
            return {
                ...state,
                selectedTags: {}
            }
        case LOCATION_CHANGE:
            return {
                ...state,
                selectedTags: {},
                selectedCommitmentId: null,
                forceRefreshColumns: [],
                closedRowGroups: [],
                undoCommands: []

            }
        case LOOKAHEAD_HISTOGRAM_TOGGLE:
            
            return {
                ...state,
                isHistogramOpen: !state.isHistogramOpen
            }
        case SHOW_VARIANCE_DIALOG:
            return {
                ...state,
                isVarianceDialogOpen: true,
                varianceUpdate: action.payload.update
            }
        case CLOSE_VARIANCE_DIALOG:
            return {
                ...state,
                isVarianceDialogOpen: false,
                varianceUpdate: {}
            }
        case SHOW_DELETE_PPC_DIALOG:
            return {
                ...state,
                isDeletePPCDialogOpen: true,
                deletePPCId: action.payload.deletePPCId
            }
        case CLOSE_DELETE_PPC_DIALOG:

            return {
                ...state,
                isDeletePPCDialogOpen: false,
                deletePPCId: null
            }
        case HUDDLE_FILTER:
            return {
                ...state,
                huddleFilter: action.payload.filter
            }

        case HUDDLE_FILTER_UP:
            const up_date = moment(state.huddleDate,'l').isValid() ? moment(state.huddleDate,'l') : moment()
            up_date.add(1,'day')
            return {
                ...state,
                huddleDate: up_date.format('l')
            }
        case HUDDLE_FILTER_DOWN:
            const down_date = moment(state.huddleDate,'l').isValid() ? moment(state.huddleDate,'l') : moment()
            down_date.subtract(1, 'day')
            return {
                ...state,
                huddleDate: down_date.format('l')
            }
        case SELECT_PPC_COMMITMENT:
            return {
                ...state,
                selectedCommitmentId: action.payload.selectedCommitmentId
            }
        case SET_PULL_DATE_DIALOG_OPEN:
            return {
                ...state,
                isSetPullDateDialogDialogOpen: true
            }
        case SET_PULL_DATE_DIALOG_CLOSE: 
            return {
                ...state,
                isSetPullDateDialogDialogOpen: false
            }
        case ADD_PULL_DATE: 
            return {
                ...state,
                pullInfo: {
                    pullDate: action.payload.pullDate,
                    pushOrPull: action.payload.pushOrPull
                }
            }
        case ON_ADD_UNDO_COMMAND:
            const undoCommands = [...state.undoCommands]
            undoCommands.push(action.payload.command)
            const sortedUndoCommands = undoCommands.sort((a,b) => a.createdAt - b.createdAt)

            return {
                ...state,
                undoCommands: sortedUndoCommands
            }
        case ON_SHIFT_UNDO_COMMAND: 
            const _undoCommands = [...state.undoCommands]
            const _sortedUndoCommands = _undoCommands.sort((a,b) => a.createdAt - b.createdAt)
            _sortedUndoCommands.shift()
            return {
                ...state,
                undoCommands: _sortedUndoCommands
            }
        case ON_CLEAR_UNDO_COMMAND:
            return {
                ...state,
                undoCommands: []
            }
        
        case MAKE_READY_PLAN_FILTER_BY_TRADE:
            return {
                ...state,
                tradeFilter: action.payload.trade
            }
        case LOOKAHEAD_FORCE_REFRESH:
            const forceRefresh  = new Set<string>(state.forceRefreshColumns)
            forceRefresh.add(action.payload.column)
            return {
                ...state,
                forceRefreshColumns: Array.from<string>(forceRefresh)
            }
        case LOOKAHEAD_FORCE_REFRESH_CLEAR:
            return {
                ...state,
                forceRefreshColumns:[]
            }
        case firebaseConstants.actionTypes.SET: 
            if(action.path === 'SELECTED_LOOKAHEAD_TRADES') {
                return {
                    ...state, 
                    ...updateEntity('trades',state, action)  
                } 
            }

            if(action.path === 'SELECTED_LOOKAHEAD_ROW_GROUPS') {
                return  {
                        ...state, 
                        ...updateEntity('row_groups',state, action)  
                } 
                
            }

            if(action.path === 'SELECTED_LOOKAHEAD_TAGS') {
                

                const tags = updateEntity('tags',state, action)

                for (let tag in tags['tags']) {
                    tags['tags'][tag]['tagCardType'] = TagType.Lookahead
                    tags['tags'][tag].tagType = ColumnType.Lookahead
                }

                const tagsByColumn = updateColumn(state, tags['tags'], state.constraints, state.milestoneTags )

                return {
                    ...state, 
                    ...tags,
                    tagsByColumn: {...tagsByColumn}
                }       
            }

            if(action.path === 'SELECTED_LOOKAHEAD_CONSTRAINT_TAGS') {
                const constraintTags = updateEntity('constraints',state, action)

                for (let tag in constraintTags['constraints']) {
                    constraintTags['constraints'][tag]['tagCardType'] = TagType.Constraint
                    constraintTags['constraints'][tag].tagType = ColumnType.Lookahead
                }

                const tagsByColumn = updateColumn(state, state.tags, constraintTags['constraints'], state.milestoneTags )

                return {
                    ...state, 
                    ...constraintTags,
                    tagsByColumn: {...tagsByColumn}

                }  
            }

            if(action.path === 'SELECTED_LOOKAHEAD_MILESTONE_TAGS') {
                

                const milestoneTags = updateEntity('milestoneTags',state, action)

                for (let milestoneTag in milestoneTags['milestoneTags']) {
                    milestoneTags['milestoneTags'][milestoneTag]['isMilestone'] = true;
                }

                for (let tag in milestoneTags['milestoneTags']) {
                    milestoneTags['milestoneTags'][tag]['tagCardType'] = TagType.Lookahead
                    milestoneTags['milestoneTags'][tag].tagType = ColumnType.Lookahead
                }

                const tagsByColumn = updateColumn(state, state.tags, state.constraints, milestoneTags['milestoneTags'] )
                return {
                    ...state, 
                    ...milestoneTags,
                    tagsByColumn: {...tagsByColumn}
                }  
            }

            if(action.path === 'SELECTED_LOOKAHEAD_AREAS') {

                const areas = updateEntity('areas',state, action) 

                return {
                    ...state, 
                    ...areas,
                }  
            }

            if (action.path === 'SELECTED_PROJECT') {
                const project = action.data
                if(!project || !project.lookaheads) {
                    return {
                        ...state,
                        selectedLookaheadId: null
                    }
                }

                const lookaheads = project.lookaheads

                const lookaheadKeys = Object.keys(lookaheads)

                if(!!state.selectedLookaheadId && !!lookaheadKeys && !!lookaheadKeys.includes(state.selectedLookaheadId)) {
                    return state

                }

                if (!!lookaheadKeys) {
                    const lookaheadId = lookaheadKeys[0]
                    return {
                        ...state,
                        selectedLookaheadId: lookaheadId
                    }
                }
            }

            

        return state

        
        default:

            return state
    }
};


// WEBPACK FOOTER //
// ./src/modules/lookahead.reducer.ts